<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <!-- <div class="box-header">
          </div>         -->
          <div class="box-body">
            <full-calendar class='full-calendar' :options='calendarOptions' ref="holidayCalendar">
            </full-calendar>
          </div>
          <!-- <div class="box-footer">
          </div> -->
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
// https://fullcalendar.io/docs/vue
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import config from '../../config'
// import Event from 'event.js'

export default {
  name: 'Holiday',
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_ISO: config.dateFormatSql,
      listData: null,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 9999,
        SortDirection: 'ASC',
        SortExpression: 'HolidayDate',
        WhereClauseByProject: ''
      },
      calendarOptions: {
        // customButtons: {
        //   refreshButton: {
        //     text: 'Refresh'
        //     // click: () => Event.$emit('inquiry')
        //   }
        // },
        // headerToolbar: {
        //   left: 'prev,next today',
        //   center: 'title',
        //   right: 'refreshButton'
        // },
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        plugins: [
          dayGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        initialView: 'dayGridMonth',
        events: [],
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        eventDrop: this.onEventDrop,
        eventResize: this.onEventDrop,
        select: this.onDateSelect
      }
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$root.$on('inquiryHolidayByProject', (projectIds) => {
      // this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    inquiry() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose a project that you are authorized', 'info')
        return
      }

      var me = this
      let strDate = ''
      this.inquiryParam.WhereClauseByProject = 'ProjectId = ' + this.$store.state.userInfo.projects[0]
      api
        .request('Account', 'get', '/api/Holiday/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          me.calendarOptions.events = []

          var data = response.data
          data.entity.forEach(e => {
            strDate = moment(e.holidayDate, this.DATE_FORMAT).format(this.DATE_FORMAT_ISO)
            me.calendarOptions.events.push({
              id: e.id,
              title: e.name,
              date: strDate,
              start: strDate,
              end: strDate,
              allDay: true
            })
          })
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDateSelect(selectInfo) {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose a project that you are authorized', 'info')
        return
      }

      let eventName = prompt('Please enter a new title for your event')
      if (eventName) {
        var me = this
        var reqData = {
          name: eventName,
          holidayDate: moment(selectInfo.start).format(this.DATE_FORMAT),
          projectId: this.$store.state.userInfo.projects[0]
        }

        api
          .request('Account', 'post', '/api/Holiday/Create', reqData)
          .then(response => {
            if (response.data.returnStatus) {
              me.calendarOptions.events.push({
                id: response.data.entity.id,
                title: eventName,
                date: selectInfo.startStr,
                start: selectInfo.startStr,
                end: selectInfo.endStr,
                allDay: selectInfo.allDay
              })
            } else {
              SweetAlert.fire('Error', response.data.returnMessage, 'error')
            }
          })
          .catch(error => {
            var message = error.message
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    onEventClick(clickInfo) {
      if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
        var me = this
        var reqData = {
          id: clickInfo.event.id,
          name: clickInfo.event.title,
          holidayDate: moment(clickInfo.event.startStr, this.DATE_FORMAT_ISO).format(this.DATE_FORMAT),
          projectId: this.$store.state.userInfo.projects[0]
        }

        api
          .request('Account', 'post', '/api/Holiday/Delete', reqData)
          .then(response => {
            if (response.data.returnStatus) {
              clickInfo.event.remove()

              for (let i = 0; i < me.calendarOptions.events.length; i++) {
                const el = me.calendarOptions.events[i]
                if (el.id === parseInt(clickInfo.event.id)) {
                  me.calendarOptions.events.splice(i, 1)
                }
              }

              // let calendarApi = this.$refs.holidayCalendar.getApi()
              // console.log(calendarApi.getEvents())
            }
          })
          .catch(error => {
            var message = error.message
            SweetAlert.fire('Error', message, 'error')
          })
      }
    }
    // onDateClick: function(arg) {
    //   console.log(arg)
    //   alert('date click! ' + arg.dateStr)
    // },
    // handleEvents(events) {
    //   this.currentEvents = events
    // }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Holiday.vue?463475df